import * as localizationKeys from '../../consts/localization/localizationKeys';
import * as advanceDiagnosticScreenTypes from '../../consts/yap/advanceDiagnosticScreenTypes';

export default [
    {
        screen: advanceDiagnosticScreenTypes.MARKET_QURE_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_CHARGER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_HOLDER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_DESCRIPTION,
            },
            {
                isMonoDevice: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_DESCRIPTION,
            },
            {
                isMultipleIssue: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_MULTIPLE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_DESCRIPTION,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.MARKET_NON_QURE_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_CHARGER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_HOLDER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_DESCRIPTION,
            },
            {
                isMonoDevice: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_DESCRIPTION,
            },
            {
                isMultipleIssue: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ELIGIBILITY_CHECK_MULTIPLE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_NON_QURE_DESCRIPTION,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.FWU_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_CHARGER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_HOLDER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_DESCRIPTION,
            },
            {
                isMonoDevice: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_DESCRIPTION,
            },
            {
                isMultipleIssue: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_MULTIPLE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_FWU_ISSUE_FOUND_DESCRIPTION,
            },
            {
                // success flow for FWU_SCREEN
                isSuccess: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ISSUE_NOT_FOUND_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ISSUE_NOT_FOUND_UPDATE_AVAILABLE_DESCRIPTION,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.RESET_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_CHARGER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_HOLDER_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_DESCRIPTION,
            },
            {
                isMonoDevice: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_DESCRIPTION,
            },
            {
                isMultipleIssue: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_MULTIPLE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_RESET_DESCRIPTION,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.ADAPTOR_MSG_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_TITLE_CHARGER_TEXT,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_DESCRIPTION_TEXT,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_TITLE_HOLDER_TEXT,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_DESCRIPTION_TEXT,
            },
            {
                isMonoDevice: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_TITLE_TEXT,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_TITLE_TEXT,
            },
            {
                isMultipleIssue: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_TITLE_TEXT,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_ADAPTOR_DESCRIPTION_TEXT,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ELIGIBILITY_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_CHARGER_ISSUE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_HOLDER_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_HOLDER_ISSUE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_CHARGER_DESCRIPTION,
            },
        ],
    },
    {
        screen: advanceDiagnosticScreenTypes.PARTIAL_FINISH_ADAPTOR_SCREEN,
        localizations: [
            {
                isHolder: false,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_CHARGER_ISSUE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_HOLDER_DESCRIPTION,
            },
            {
                isHolder: true,
                titleKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_HOLDER_ISSUE_TITLE,
                descriptionKey: localizationKeys.ADVANCED_DIAGNOSTICS_PARTIAL_CHARGER_DESCRIPTION,
            },
        ],
    },
];
